import { useState } from 'react'
import { useScopeStore } from '../store'
import { DrawerSection, normalizeTriState } from './advanced/shared'
import { AdvancedGeneralSection } from './advanced/GeneralSection'
import { AdvancedKycSection } from './advanced/KycSection'
import { AdvancedAmlSection } from './advanced/AmlSection'
import { AdvancedIdvSection } from './advanced/IdvSection'
import { AdvancedKybSection } from './advanced/KybSection'
import { AdvancedRulesSection } from './advanced/RulesSection'

export function AdvancedTab() {
  const { scope } = useScopeStore()
  const { kycConfig, amlConfig } = scope

  const kycRequiredValue = normalizeTriState(kycConfig.kycRequired)

  const [openDrawers, setOpenDrawers] = useState<Record<string, boolean>>({
    general: true,
    kyc: false,
    aml: false,
    biometrics: false,
    kyb: false,
    rules: false,
  })

  const toggleDrawer = (key: string) => {
    setOpenDrawers((prev) => ({ ...prev, [key]: !prev[key] }))
  }

  return (
    <div className="space-y-6">
      <DrawerSection
        title="General"
        subtitle="Corporate structure, testing, billing, and SOW variation"
        isOpen={openDrawers.general}
        onToggle={() => toggleDrawer('general')}
      >
        <AdvancedGeneralSection />
      </DrawerSection>

      {kycRequiredValue !== 'no' && (
        <DrawerSection
          title="KYC"
          subtitle="Reporting entity, vendor, compliance, rulesets, and aging"
          isOpen={openDrawers.kyc}
          onToggle={() => toggleDrawer('kyc')}
        >
          <AdvancedKycSection />
        </DrawerSection>
      )}

      {amlConfig.level !== 'na' && (
        <DrawerSection
          title="AML"
          subtitle="Relationship, vendor, fuzziness, PEP enrichment, batch processing, and aging"
          isOpen={openDrawers.aml}
          onToggle={() => toggleDrawer('aml')}
        >
          <AdvancedAmlSection />
        </DrawerSection>
      )}

      <DrawerSection
        title="Biometrics & IDV"
        subtitle="Platform selection"
        isOpen={openDrawers.biometrics}
        onToggle={() => toggleDrawer('biometrics')}
      >
        <AdvancedIdvSection />
      </DrawerSection>

      <DrawerSection
        title="KYB"
        subtitle="Entity types and data aging"
        isOpen={openDrawers.kyb}
        onToggle={() => toggleDrawer('kyb')}
      >
        <AdvancedKybSection />
      </DrawerSection>

      <DrawerSection
        title="Rules & Matching"
        subtitle="Duplicate detection and blocklist matching"
        isOpen={openDrawers.rules}
        onToggle={() => toggleDrawer('rules')}
      >
        <AdvancedRulesSection />
      </DrawerSection>
    </div>
  )
}
